module.exports = __webpack_public_path__ + "img/template-circle-3.ecc00467.png";